import { css } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { MOBILE } from '../../../../utils/constants';
import Button from '@atlaskit/button';
import { FormApi } from '@atlaskit/form';
import useCreateResponse, { type ResponseFormData } from 'hooks/ai-forums/useCreateResponse';
import Form from '@atlaskit/form';
import { Field } from '@atlaskit/form';
import TextArea from '@atlaskit/textarea';
// import Editor from 'components/Editor/Editor';

interface Props {
  postId: string;
}

export default function SuggestAnswer({ postId }: Props) {
  const { createResponse, isPending } = useCreateResponse();

  const handleSubmit = async (data: ResponseFormData, form: FormApi<ResponseFormData>) => {
    try {
      await createResponse(postId, data, {
        onSuccess: (response) => {
          form.reset();
          window.location.reload();
        },
        onError: (errors) => {
          console.log('errors', errors);
        },
      });
    } catch (validationErrors) {
      return validationErrors;
    }
  };

  return (
    <div css={suggestSectionStyles}>
      <div css={suggestHeaderStyles}>
        <span css={suggestAvatarStyles}>RK</span>
        <span css={suggestLabelStyles}>Suggest an answer</span>
      </div>
      <Form<ResponseFormData> onSubmit={handleSubmit}>
        {({ formProps }) => (
          <form {...formProps} noValidate>
            <Field name="content">
              {({ fieldProps }) => (
                <div>
                  <TextArea
                    value={fieldProps.value}
                    onChange={(e) => fieldProps.onChange(e.currentTarget.value)}
                    placeholder="Type your answer ..."
                    minimumRows={3}
                    css={suggestTextareaStyles}
                  />
                </div>
              )}
            </Field>
            <Field name="content">
              {({ fieldProps }) => (
                <div css={buttonContainerStyles}>
                  <Button appearance="primary" type="submit" isDisabled={isPending || !fieldProps.value}>
                    {isPending ? 'Submitting...' : 'Submit'}
                  </Button>
                </div>
              )}
            </Field>
          </form>
        )}
      </Form>
    </div>
  );
}

const suggestSectionStyles = css({
  background: token('elevation.surface'),
  borderRadius: '8px',
  padding: '24px',
  margin: '24px 0 0 0',
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
  [MOBILE.MEDIA_QUERY]: {
    padding: '12px',
    margin: '16px 0 0 0',
  },
});

const suggestHeaderStyles = css({
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
  marginBottom: '4px',
});

const suggestAvatarStyles = css({
  width: '32px',
  height: '32px',
  borderRadius: '50%',
  background: token('color.background.discovery.bold'),
  color: token('color.text.inverse'),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontWeight: 700,
  fontSize: '16px',
  fontFamily: 'Charlie Text, sans-serif',
});

const suggestLabelStyles = css({
  fontWeight: 600,
  fontSize: '16px',
  color: token('color.text'),
  fontFamily: 'Charlie Text, sans-serif',
});

const suggestTextareaStyles = css({
  width: '100%',
  minHeight: '60px',
  borderRadius: '6px',
  border: `1px solid ${token('color.border')}`,
  padding: '10px',
  fontSize: '15px',
  fontFamily: 'Charlie Text, sans-serif',
  color: token('color.text'),
  background: token('elevation.surface'),
  resize: 'vertical',
  marginBottom: '8px',
  '&:focus': {
    outline: 'none',
    borderColor: token('color.border.focused'),
    boxShadow: `0 0 0 2px ${token('color.border.focused')}`,
  },
});

const buttonContainerStyles = css({
  display: 'flex',
  justifyContent: 'flex-end',
});
